import { z } from "zod";

export const communityCoverImageSchema = z.object({
	url: z.url(),
	alt: z.string().max(200).optional(),
	order: z.number().int().min(0),
});

export type CommunityCoverImage = z.infer<typeof communityCoverImageSchema>;
